// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"511":"744fc0ed","596":"8c884869","750":"efd506ed","755":"fae8743b","924":"b2e2f352"}[chunkId] + ".css";
};